import { Grid, IconButton, Modal as MaterialModal, Typography } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import React, { useContext } from 'react';
import { PayPalButton } from 'react-paypal-button-v2';

import { ctx, IStore } from 'store';

import { useStyles } from './styles';

const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;

interface IProps {
  amount: number;
  closeModal: () => void;
  modalStatus: boolean;
  month: string;
}

const Modal: React.FC<IProps> = ({ amount, closeModal, modalStatus, month }) => {
  const classes = useStyles();
  const actions = useContext(ctx.actions);
  const {
    teams: { currentTeam },
  } = useContext(ctx.store);

  return (
    <MaterialModal open={modalStatus} onClose={() => closeModal()}>
      <Grid className={classes.paper}>
        <IconButton onClick={() => closeModal()} className={classes.close}>
          <Close />
        </IconButton>
        <Typography className={classes.title}>{`Amount to be paid: ${amount.toFixed(
          2
        )}`}</Typography>
        <PayPalButton
          amount={amount}
          shippingPreference="NO_SHIPPING"
          onSuccess={async (_details: any, data: any) => {
            await ((actions.teams.sendPayment(
              currentTeam.teamId ? currentTeam.teamId : currentTeam.tenantId,
              month,
              data.orderID
            ) as unknown) as Promise<IStore>);

            closeModal();
          }}
          options={{
            clientId: PAYPAL_CLIENT_ID,
          }}
        />
      </Grid>
    </MaterialModal>
  );
};

export { Modal };
